
function determinePcScreen(): boolean {
    return document.body.clientWidth > 1000 ? true : false;
}


export { determinePcScreen }


